import { render, staticRenderFns } from "./MetricIndexToggle.vue?vue&type=template&id=65dbd430&"
import script from "./MetricIndexToggle.vue?vue&type=script&lang=js&"
export * from "./MetricIndexToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports